import { render, staticRenderFns } from "./ModalLabels.vue?vue&type=template&id=d10925e4&lang=pug&"
import script from "./ModalLabels.vue?vue&type=script&lang=js&"
export * from "./ModalLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports